<script context='module'>
  // Appearances
  export const INFO = 'info';
  export const SUCCESS = 'success';
  export const ERROR = 'error';
  export const DEFAULT = INFO;
</script>

<script>
  import Message, { ERROR as MESSAGE_ERROR } from '../Message';
  import Expandable from '../Expandable';
  import TrayBase from './TrayBase.svelte';
  import HeadingS from '../Heading/HeadingS.svelte';

  export let testid = undefined;
  export let position = 'bottom';
  export let error = undefined;
  export let appearance = DEFAULT;
  export let tray;
</script>

<TrayBase bind:this={tray} {position} let:dismiss on:dismiss on:remove>
  <div class='accent-bar {appearance}'></div>
  <Expandable>
    <div class='tray-content {appearance}' data-cy={testid}>
      <div class='tray-row'>
        <div class='message'>
          <HeadingS><slot {dismiss} /></HeadingS>
        </div>
        <div class='actions'>
          <slot name='actions'/>
        </div>
      </div>
      {#if error}
        <div class='tray-row'>
          <Message appearance={MESSAGE_ERROR}>{error}</Message>
        </div>
      {/if}
    </div>
  </Expandable>
</TrayBase>

<style lang="postcss">
  .info {
    --tray--accent--color: var(--color--blue);
  }

  .success {
    --tray--accent--color: var(--color--brand-dark-green);
  }

  .error {
    --tray--accent--color: var(--color--red);
  }

  .accent-bar {
    background-color: var(--tray--accent--color);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--spacing--xxs);
  }

  .tray-content .message :global(*) {
    color: var(--tray--accent--color);
  }

  .message {
    margin-right: 18px;
  }

  .tray-content {
    display: flex;
    padding: 24px;
    gap: 12px;
    justify-content: stretch;
    max-height: 90vh;
    max-width: var(--size--overlay--medium);
    flex-direction: column;
  }

  .tray-row {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: stretch;
    align-content: space-between;
    min-height: 40px;

    & > * {
      flex-grow: 1;
    }
  }

  .actions {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
  }
</style>
